import { gql, useMutation, useLazyQuery, DocumentNode } from '@apollo/client';
import { UserData } from '../services/auth.service';

const EXCHANGE_OAUTH_TOKEN: DocumentNode = gql`
  mutation ExchangeOAuthToken($token: String!) {
    exchangeOAuthToken(token: $token)
  }
`;

const GET_USER_LOGGIN_AUTH_HOOK: DocumentNode = gql`
  query GetUserLogginAuthHook {
    GetUserLoggin {
      __typename
      _id
      name
      lastName
      email
      phone
      createdAt
    }
  }
`;

export const useExchangeOAuthToken = () => {
  const [exchangeOAuthToken, { data, loading, error }] = useMutation(
    EXCHANGE_OAUTH_TOKEN,
    { fetchPolicy: 'no-cache' }
  );

  return {
    exchangeOAuthToken,
    data,
    loading,
    error
  };
};

export const useGetUserLoggin = () => {
  const [getUserLoggin, { data, loading, error }] = useLazyQuery<{ GetUserLoggin: UserData }>(
    GET_USER_LOGGIN_AUTH_HOOK,
    { fetchPolicy: 'no-cache' }
  );

  return {
    getUserLoggin,
    data,
    loading,
    error
  };
};

// Login mutation for existing users (Onboarding)
const LOGIN_ONBOARDING: DocumentNode = gql`
  mutation LoginOnboarding($loginUserInput: LoginUserInput!) {
    login(loginUserInput: $loginUserInput) {
      user {
        _id
        name
        __typename
      }
      authToken
      __typename
    }
  }
`;

export const useLogin = () => {
  const [login, { data, loading, error }] = useMutation(LOGIN_ONBOARDING, { fetchPolicy: 'no-cache' });

  return {
    login,
    data,
    loading,
    error
  };
};
